function SidebarFooter() {
  return null;
}

export default SidebarFooter;
